import React, { Component } from 'react'
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import Collapse from "@kunukn/react-collapse";
import classes from './Collapse.module.css';
import CollapseDiv from './CollapseDiv/CollapseDiv'
class SyllCollapse extends Component {
    state = {
        open: false
    }
    onClickHandler = () => {
        this.setState({ open: !this.state.open })
    }
    render() {
        let style = null
        if(this.props.count==0){
            style = {
                "backgroundColor":"#4c8f7b"
            }
        }
        else if(this.props.count%2==1){
            style = {
                "backgroundColor":"#6d4a4a"
            }
        }
        else if(this.props.count%2==0){
            style = {
                "backgroundColor":"#db974d"
            }
        }
        let arrow = (<DownOutlined />)
        let headerClass = [classes.header]
        if (this.state.open) {
            headerClass = [classes.header,classes.headerOpen]
            arrow = <UpOutlined />
        }
        console.log(this.props.data.subject_syllabus)
        return (
            <div className={classes.container}>
                <div style = {style} className={headerClass.join(" ")}
                    onClick={this.onClickHandler}>
                    <p className={classes.title}>{this.props.data.subject_name}</p>
                    <div className={classes.arrow}>{arrow}</div>
                </div>
                <Collapse isOpen={this.state.open}
                    transition={`height 290ms cubic-bezier(.4, 0, .2, 1)`}
                    className={classes.collapse}  >
                    <div>
                   <CollapseDiv data = {this.props.data.subject_syllabus}/>
                   </div> 
                </Collapse>
                </div>
    )
  }

}

export default SyllCollapse;